export class ControlNotFoundError extends Error {
    constructor(message?: string) {
      super(message);
      this.name = 'ControlNotFoundError';
      Object.setPrototypeOf(this, ControlNotFoundError.prototype);
    }
  }